export default __webpack_public_path__ + "static/media/Digital_Delivery.8bc30014.svg";